export default "__VITE_ASSET__b3a87e41__"